<template src="./Payment-Retry.html"/>
<style lang="scss" scoped src="./Payment-Retry.scss"/>

<script>


import CartPreview from '@/components/Checkout/CartPreview';

import {
    SfHeading,
    SfCheckbox,
    SfButton,
    SfIcon,
    SfLink,
    SfLoader,
    SfRadio,
} from '@storefront-ui/vue';

import UserAddress from '@/components/UserAddress.vue';
import OrkLoader from '@/components/Ork/OrkLoader';
import OrkAdyenPayment from '@/components/Checkout/AdyenPaymentProvider';
import CardPictos from '@/components/Checkout/CardPictos';
import Api from "@/api/Api";
import icons from "@/utils/icons";

import {ShoppingCart} from "@/models/shopping";

export default {
    name: 'PaymentRetry',
    layout: 'checkout',

    components: {
        OrkLoader,
        CartPreview,
        CardPictos,
        UserAddress,
        SfLoader,
        SfRadio,
        SfHeading,
        SfCheckbox,
        SfButton,
        SfIcon,
        SfLink,
        OrkAdyenPayment,
    },
    data() {
        return {
            terms: false,
            paymentReady: false,
            giftCard: null,
            ip: null,
            icons: icons,
            loading: false,
            error: null,
            paymentMethod: 'card',
            state: {isValid: false},
            dropin: null,
            orderId: null,
            billingAddress: null,
            hasBilling: false,
            hasShipping: false,
            currentCart: null,
            loadingPayment: true,

        };
    },
    computed: {
        customer: {
            get() {
                return this.$store.getters.getProfile;
            },
            set() {

            }
        },

    },
    watch: {
        customer(newCustomer) {
            if (!newCustomer) {
                // this.router.push('/');
            }

        },
    },
    mounted() {
        this.getIP();

        if (!this.$route.params.shoppingCartUUID) {
            this.goToHome()
        } else {
            this.getPaymentCart(this.$route.params.shoppingCartUUID)
        }

    },
    methods: {
        getPaymentCart(shoppingCartUUID) {
            this.loadingPayment = true;
            Api.payment.RetryOrderByUuid(shoppingCartUUID).then((data) => {
                this.currentCart = ShoppingCart.of(data);
                this.loadingPayment = false
            }).catch((e) => {
                let error = null;
                switch (e.status) {
                    case 401:
                        error = this.$i18n.t('errors.unauthorized')
                        break;
                    case 500:
                        error = this.$i18n.t('errors.server.access')
                        break;
                }
                if (error) {
                    this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
                }
                this.loadingPayment = false
            })
        },
        goToHome() {
            this.$router.push(this.$localizePath('/')).catch();
        },

        getIP() {
            this.ip = Api.payment.getIP();
        },
        handleResult(result) {
            this.loading = false
            if (result.resultCode.toLowerCase() === "authorised") {
                this.$router.push(this.$localizePath(`/commande/merci/${result.merchantReference}`)).catch(() => {
                    return null
                });

            } else if (result.error) {
                const error = result.error;
                if (error.status === 400) {
                    const offers = [];
                    const offersId = [];
                    offersId.push(error.message.split("'")[1]);

                    offersId.forEach((id) => {
                        this.currentCart.cartItems.map((item) => {
                            if (item.product.offer.id === id) {
                                offers.push(item);
                                item.noStock = true;
                            }
                        });
                    });
                    sessionStorage.setItem('NoStockItems', JSON.stringify(offersId));

                    if (offers.length > 0) {
                        this.$store.dispatch('toggleNoStockActionModal', {open: true, products: offers})
                    } else {
                        error.message = this.$i18n.t("errors.billing.address");
                    }
                    this.$store.dispatch("sendNotification", {type: "danger", message: error.message, icon: "error"});
                }
            } else {
                this.$router.push(this.$localizePath("/commande/paiement/resultat?data=" + encodeURIComponent(btoa(JSON.stringify(result)))));
            }
        },


        setPaymentMethod(method) {
            this.paymentMethod = method
        },

        processOrder() {
            if (this.state && this.state.isValid) {
                this.loading = true;
                const state = this.state;
                const dropin = this.dropin;
                this.$refs.OrkAdyenPayment.submitPayment({state, dropin}, this.currentCart);

            }
        },
        paymentAction(event) {
            this.state = event.state;
            this.dropin = event.dropin;
            if (event.state.isValid) {
                this.paymentReady = true;
            } else {
                this.paymentReady = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.coupon {
  display: flex;
  flex-wrap: wrap;
  background: var(--c-primary) url("/assets/images/fd_coupon.webp") no-repeat center;
  background-size: cover;
  color: var(--c-white);
  padding: var(--spacer-sm);
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  margin: var(--spacer-lg) 0 var(--spacer-base);

  &-label {
    display: block;
    align-items: center;
    font-size: 1.875rem;
    font-weight: 700;
    //text-transform: uppercase;
    width: 100%;

    .title {
      display: flex;
      width: 100%;

    }

    .text {

      align-items: center;
      width: 100%;
      display: flex;
      min-height: 42px;
      line-height: 42px;
      margin-left: var(--spacer-xs);
    }

    .desc {
      font-size: var(--font-size--base);
      font-weight: 400;
      text-transform: none;
      margin-left: var(--spacer-xs);
    }
  }

  .content {
    display: flex;

    > * {
      flex: 0 0 1;
    }

    .desc {
      width: 50%;
    }
  }

  &-form {
    flex: 1;
    position: relative;
    padding: 0;
    margin: 0;

    .sf-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      height: 42px;
      //  text-transform: uppercase;
    }
  }

  ::v-deep {

    .sf-input {
      margin-bottom: 0;

      &__wrapper {
        margin: var(--input-margin, 0 0 0 0);
      }

      &__error-message {
        display: none;
      }

    }
  }
}

.payment-method__card {
  .content {
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;
    gap: var(--spacer-base);

    .address, .payment {
      width: 50%;
      flex: 1;
      @include for-mobile {
        width: 100%;
        flex: none;
        flex-wrap: wrap;
      }

      .sf-heading {
        margin-bottom: var(--spacer-base);
      }


    }

    .address {
      margin: 0 0;

      position: relative;


      .user-address {
        border: none;
        margin-right: var(--spacer-base);
        margin-bottom: var(--spacer-sm);
        cursor: pointer;
      }


      &::after {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: block;
        content: '';
        width: 1px;
        background-color: var(--_c-lightgray);
        @include for-mobile {
          position: relative;
          width: 100%;
          height: 1px;
          margin: var(--spacer-base) 0;
        }
      }
    }

    .payment {
      .sf-button {
        @include for-mobile {
          width: 100%;
        }
      }

      .summary__terms {
        margin: var(--spacer-base) 0;

        .sf-link {
          font-size: var(--font-size--base);
        }
      }
    }
  }
}

.user-address {
  cursor: pointer;
}

div[class^='payment-method_'] {
  border: 1px solid var(--_c-primary-light);
  border-radius: 4px;
  padding: var(--spacer-base);
  @include for-mobile {
    padding: var(--spacer-sm);
  }
  margin: var(--spacer-base) 0;
  box-shadow: 0 2px 6px -2px rgb(0 0 0 / 10%);

  &:hover, &.is-active {
    box-shadow: 0 2px 6px -2px rgb(0 0 0 / 25%);
  }

  .sf-radio .label {
    display: flex;
    align-items: center;

    .text {
      flex: 1;
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      margin-left: var(--spacer-xs);
      font-size: var(--font-size--lg);
      // text-transform: uppercase;
      font-weight: var(--font-weight--bold);

    }
  }
}

::v-deep {
  .sf-radio__container {
    display: flex;
    align-items: center;
  }
}

.sf-radio.is-active {
  background: none;
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-mobile {

  }

  .sf-button {
    width: fit-content;

    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}
</style>
